import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MainRoutingModule } from './main-routing.module';
import { MainComponent } from './main.component';
import { PhotosComponent } from './photos/photos.component';
import { SharedModule } from '../shared/shared.module';
import { QuestionsComponent } from './questions/questions.component';
import { SummaryComponent } from './summary/summary.component';
import { ResponseComponent } from './response/response.component';
import { LoaderComponent } from '../core/loader/loader.component';

@NgModule({
  declarations: [LoaderComponent,MainComponent, QuestionsComponent, PhotosComponent, SummaryComponent, ResponseComponent],
  imports: [
    SharedModule,
    MainRoutingModule
  ],
  exports: [
    MainComponent
  ]
})
export class MainModule { }
